import { TravelInsuranceIcon } from 'components/svgs/TravelInsuranceIcon';
import { PurchaseProtectionIcon } from 'components/svgs/PurchaseProtectionIcon';
import { SmartPhoneIcon } from 'components/svgs/SmartPhoneIcon';
import { RentalIcon } from 'components/svgs/RentalIcon';
import { LossDmgIcon } from 'components/svgs/LossDmgIcon';
import { PriceProtectionIcon } from 'components/svgs/PriceProtectionIcon';
import { ExtendedWarrantyIcon } from 'components/svgs/ExtendWarranty';
import { TravelAccidentIcon } from 'components/svgs/TravelAccidentIcon';

export const CreditCardBenefitsImg = {
  ['Travel Insurance']: TravelInsuranceIcon,
  ['Overseas Travel Insurance']: TravelInsuranceIcon,
  ['Purchase Protection']: PurchaseProtectionIcon,
  ['Purchase Protection Insurance']: PurchaseProtectionIcon,
  ['Smartphone Screen Cover']: SmartPhoneIcon,
  ['Rental Vehicle Excess Cover']: RentalIcon,
  ['Loss Damage Waiver']: LossDmgIcon,
  ['PriceGuard']: PriceProtectionIcon,
  ['Extended Warranty']: ExtendedWarrantyIcon,
  ['Extended Warranty Insurance']: ExtendedWarrantyIcon,
  ['Travel Accident and Card account balance waiver cover']: TravelAccidentIcon,
  default: ExtendedWarrantyIcon,
};
